import React from 'react';

const ClubCrownIcon = ({ className = "text-warning ms-1", title = "Clube", ...props }) => {
    return (
        <i 
            className={`fa-solid fa-crown ${className}`} 
            title={title} 
            {...props}
        ></i>
    );
};

export default ClubCrownIcon;
